<template>
  <el-card
    header="Quoted Pricing"
    shadow="never"
  >
    <template slot="header">
      <div class="clearfix">
        <span>Quoted Pricing</span>
        &nbsp;
        <el-tooltip
          class="item"
          effect="dark"
          content="This pricing is shown to the customer when consigning, if a service was manually selected only one entry will be shown. If the service was manually selected and no pricing is available then no entires will be shown."
          placement="right-start"
        >
          <i class="el-icon-info" />
        </el-tooltip>
        <!-- <el-button-group style="float: right;">
          <el-button
            v-clipboard:copy="pricingDetails"
            v-clipboard:success="() => $message.success('Pricing copied to clipboard')"
            style="padding: 3px 0"
            type="text"
          >
            Copy
          </el-button>
        </el-button-group> -->
      </div>
    </template>
    <el-table
      :data="pricing"
      border
      style="width: 100%"
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-card
            shadow="never"
            class="w-100"
          >
            <el-table :data="props.row.fees">
              <el-table-column
                prop="description"
                label="Description"
              />
              <el-table-column
                prop="rate"
                label="Rate"
              />
            </el-table>
          </el-card>
        </template>
      </el-table-column>
      <el-table-column
        prop="service_code"
        label="Service Code"
        sortable
        :formatter="(row, col, cellValue) => row.service_name + ` [${row.service_chainit}]`"
      />
      <el-table-column
        prop="rate"
        label="Rate"
        sortable
      />
      <el-table-column
        prop="fuel"
        label="Fuel"
        sortable
      />
      <el-table-column
        prop="fees"
        label="Fees"
        sortable
        :formatter="(row, col, cellValue) => cellValue ? 'Yes' : 'No'"
      />
      <el-table-column
        prop="tax"
        label="Tax"
        sortable
      />
    </el-table>
  </el-card>
</template>
<script>
export default {
  props: {
    pricing: {
      type: Array,
      default: () => []
    }
  }
}
</script>
